import React from 'react'
import './header.css'
import CTA from './CTA'
import HeaderSocials from './HeaderSocials'

const getCurrentYear = () => {
  return new Date().getFullYear() - 2018;
};

const Header = () => {
  return (
    <header id='home'>
      <div className="container header__container">
        <h5>Hi my name is</h5>
        <h1><b>Sang Hwa, Choi</b></h1>
        <h1>I build future.</h1>
        <h3>I am very passionate about distributed systems and solving complex problems.<br />
        I have {getCurrentYear()}+ years of experiences developing performant and scalable applications. <br />
        I specialize in back-end development and have also done some front-end programming. <br />
        My programming skills include C#, PHP, JavaScript and SQL, and I have knowelege of ASP.NET, react.js, Node.js, AWS, Azure. <br />
        I am a good team player with strong communication skills and problem solving skills. </h3>
        {/* <h5 className="text-light">Software Enginner</h5> */}
        <CTA />
      </div>
      <HeaderSocials></HeaderSocials>
      {/* <a href="#contact" className='scroll__down'>Scroll Down</a> */}
    </header>
  )
}

export default Header
